import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-gestion-cabinets-comptables',
  templateUrl: './gestion-cabinets-comptables.component.html',
  styleUrls: ['./gestion-cabinets-comptables.component.scss']
})
export class GestionCabinetsComptablesComponent implements OnInit {

  configuration = this.configurationService.get();

  constructor(private configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }

}
